module.exports = __webpack_public_path__ + "img/slide3_img3.d63329f2.png";